import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateContact, privateContactsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const PRIVATE_CONTACT_MODULE = 'privateContact';

const state = { matches: new Map() };

const dataObjectModule = getDataObjectsModule<IPrivateContact>(privateContactsManager, 3);
const searchModule = getSearchModule<IPrivateContact>(privateContactsManager);

const privateContactModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, getters, actions, mutations });
store.registerModule(PRIVATE_CONTACT_MODULE, privateContactModuleInstance);

export { PRIVATE_CONTACT_MODULE };
